@if (assets().length === 0) {
  <div class="row flex-between-center border my-2">
    <div class="col-auto my-2">
      <label class="data-labels">—</label>
    </div>
  </div>
} @else {
  @for (asset of assets(); track asset.id) {
    <div class="row flex-between-center border my-2">
      <div class="col-auto my-2">
        <labeled-content [label]="translationKey + 'loanProvider' | translate">
          <label class="data-labels">{{ asset.name || "—" }}</label>
        </labeled-content>
      </div>
      <div class="col-auto my-2">
        <labeled-content [label]="translationKey + 'loanAmount' | translate">
          <label class="data-labels">{{ loanAmount(asset) }}</label>
        </labeled-content>
      </div>
      <div class="col-auto my-2">
        <labeled-content [label]="translationKey + 'loanExpiration' | translate">
          <label class="data-labels">{{
            asset.end ? (asset.end | date : "mediumDate") : "—"
          }}</label>
        </labeled-content>
      </div>
      <div class="col-auto my-2">
        <labeled-content [label]="translationKey + 'reason' | translate">
          <label class="data-labels">{{ reason(asset) }}</label>
        </labeled-content>
      </div>
    </div>
  }
}
